/**
 * @fileoverview gRPC-Web generated client stub for external
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var external_filters_pb = require('./filters_pb.js')
const proto = {};
proto.external = require('./geo_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.GeoServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.external.GeoServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.external.GetAllGeoRequest,
 *   !proto.external.GetAllGeoResponse>}
 */
const methodDescriptor_GeoService_GetAll = new grpc.web.MethodDescriptor(
  '/external.GeoService/GetAll',
  grpc.web.MethodType.UNARY,
  proto.external.GetAllGeoRequest,
  proto.external.GetAllGeoResponse,
  /**
   * @param {!proto.external.GetAllGeoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetAllGeoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.external.GetAllGeoRequest,
 *   !proto.external.GetAllGeoResponse>}
 */
const methodInfo_GeoService_GetAll = new grpc.web.AbstractClientBase.MethodInfo(
  proto.external.GetAllGeoResponse,
  /**
   * @param {!proto.external.GetAllGeoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.external.GetAllGeoResponse.deserializeBinary
);


/**
 * @param {!proto.external.GetAllGeoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.external.GetAllGeoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.external.GetAllGeoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.external.GeoServiceClient.prototype.getAll =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/external.GeoService/GetAll',
      request,
      metadata || {},
      methodDescriptor_GeoService_GetAll,
      callback);
};


/**
 * @param {!proto.external.GetAllGeoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.external.GetAllGeoResponse>}
 *     Promise that resolves to the response
 */
proto.external.GeoServicePromiseClient.prototype.getAll =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/external.GeoService/GetAll',
      request,
      metadata || {},
      methodDescriptor_GeoService_GetAll);
};


module.exports = proto.external;

